import React, { useEffect, useState, Suspense, lazy } from "react";
import { ThemeProvider } from "styled-components";
import "animate.css";
import "aos/dist/aos.css";
import AOS from "aos";
import "../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "./App.css";
import "./assets/styles/global/style.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Resetpassword from "./pages/static/ResetPassword";
import "bootstrap/dist/css/bootstrap.min.css";
// import Loginscreen from "../src/pages/static/en/loginscreen";
import Sidebar from "./layouts/Sidebar";
import { Route, Switch } from "react-router-dom";
import { API_URL, SUB_DOMAIN_NAME } from "./redux/constants/type";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CloseButton from "./components/Common/CloseButton";
import { useDispatch } from "react-redux";
import { memo } from "react";
import UserNotification from "./utils/helpers/notifications";
import ServerTimeOutPage from "./pages/static/server/ServerTimeout";
import { ServerLoginPage } from "./pages/static/server/ServerLogin";
import QuoteClientSign from "./pages/static/quote/quote-client.sign";
import PurchaseOrderEmailWorker from "./components/Assets/Purchasing/PurchaseOrderEmailWorker";
import RentOrderEmailWorker from "./components/Assets/Purchasing/RentOrderEmailWorker";

import UserVerification from "./pages/static/en/UserVerification";
import MakeNewPassword from "./pages/static/en/MakeNewPassword";
import WidgetForm from "./components/ChatWidget/userPanel/WidgetForm";
import Form from "./pages/static/forms/Form";
import NetworkStatus from "./utils/helpers/NetworkStatus";
import TimerActivityRun from "./utils/timerActivity/TimerActivityRun";
import IdleTimer from "./utils/timerActivity/IdleTimer";
import Loader from "./components/Dailogs/Loader";
const Loginscreen = lazy(() => import("../src/pages/static/en/loginscreen"));

const defaultTheme = {
  status: true,
  message: "Fetched Successfully",
  data: [
    {
      companyid: "28830f30-b321-4662-a576-f23451677734",
      companyname: "Spire Essentials",
      companylogo:
        "https://spire-solutions-dev.s3.ap-south-1.amazonaws.com/Group 3219@2x.png",
      logowithtitle:
        "https://spire-solutions-dev.s3.ap-south-1.amazonaws.com/SpireEssentials Logo@2x.png",
      backgroundcolor: "#FFFFFF",
      backgroundimage:
        "https://spire-solutions-dev.s3.ap-south-1.amazonaws.com/blanco briefpapier (1)_page-0001.jpg",
      primarycolor: "#00246A",
      secondarycolor: "#FFFFFF",
      textcolor: "#333333",
      label: "#707070",
      ispaymentexpired: 0,
      domain: "https://essentials-dev.spire.solutions",
      billingInformationid: "cbea0b5e-202e-4355-949a-f12720dca294",
    },
  ],
};

function App() {
  const [FetchCompanyDetailsRes, setFetchCompanyDetailsRes] = useState(
    defaultTheme.data,
  );

  // const dispatch = useDispatch();
  // dispatch({
  //   type: SUB_DOMAIN_NAME,
  //   data: defaultTheme,
  // });

  const currentPageUrl = window.location.host.split(".")[0].trim();
  const localUrl = currentPageUrl.split(":")[0].trim();

  if (localUrl === "localhost") {
    let subDomainName = "essentials-dev";
    localStorage.setItem("workspaceName", subDomainName);
  } else {
    localStorage.setItem("workspaceName", localUrl);
  }

  const updateFetchCompanyDetailsRes = (data) => {
    // setFetchCompanyDetailsRes(data);
  };

  const theme = {
    main: FetchCompanyDetailsRes || defaultTheme,
  };

  // Initialize AOS by ASC
  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <>
      <ThemeProvider theme={theme}>
        <NotificationConteiner />
        <UserNotification />
        <PurchaseOrderEmailWorker />
        <RentOrderEmailWorker />
        <NetworkStatus />
        {/* <TimerActivityRun /> */}
        {/* <IdleTimer /> */}

        <Suspense fallback={<Loader />}>
          <Switch>
            <Route
              path="/"
              exact={true}
              render={(props) => (
                <Loginscreen
                  {...props}
                  updateFetchCompanyDetailsRes={updateFetchCompanyDetailsRes}
                />
              )}
            />
            <Route path="/chatWidget" exact={true} component={WidgetForm} />
            <Route
              path="/user-verification/:userid"
              exact={true}
              render={(props) => (
                <Loginscreen
                  {...props}
                  updateFetchCompanyDetailsRes={updateFetchCompanyDetailsRes}
                />
              )}
            />
            <Route
              exact
              path="/resetpassword/:userid"
              component={Resetpassword}
            />

            <Route
              exact
              path="/UserVerification/:userid"
              component={UserVerification}
            />
            <Route
              exact
              path="/MakeNewPassword/:userid"
              component={MakeNewPassword}
            />

            <Route path="/server-login" component={ServerLoginPage} />
            <Route path="/server-timeout" component={ServerTimeOutPage} />
            <Route path="/quote/:quoteid/sign" component={QuoteClientSign} />
            <Route path="/form/:formId/sign" component={Form} />
            <Route exact={true} component={Sidebar} />
          </Switch>
        </Suspense>
      </ThemeProvider>
    </>
  );
}

const NotificationConteiner = memo(() => {
  return (
    <ToastContainer
      limit={1}
      hideProgressBar={true}
      closeOnClick={false}
      closeButton={CloseButton}
      autoClose={5000}
    />
  );
});

export default App;
